export default "__VITE_PUBLIC_ASSET__0d361bc6__"